import { BacklogState, PlanningViewBy } from "../types";

export const initialState: BacklogState = {
  isLoading: false,
  isPlanningFilterLoading: false,
  planningItems: {
    backlog: { totalTickets: 0, ticketIds: [], ticketTypes: [] },
    selectedView: { viewBy: PlanningViewBy.COMPONENTS, groups: [] },
  },
  selectedViewType: null,
  selectedPlanningTile: null,
};
